import React from 'react';
import { ApolloError } from '@apollo/client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  IPaginationProps,
  LinearProgress,
  LoadedContent,
} from '@occc-app/design-system';

import { CampaignComponent } from './types';
import { ComponentTableRow } from './ComponentsTableRow';

type CampaignComponentsProps = {
  campaignComponents: CampaignComponent[] | null;
  loading: boolean;
  error?: ApolloError;
  onRowClick: (id: string) => void;
  paginationProps: IPaginationProps;
  isActionsColumnVisible: boolean;
};

export const CampaignComponentsTable = ({
  campaignComponents,
  loading,
  error,
  onRowClick,
  paginationProps,
  isActionsColumnVisible,
}: CampaignComponentsProps) => {
  const renderData = (items: CampaignComponent[]) => {
    return (
      <>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Marketing Content</TableCell>
              <TableCell>Publication Status</TableCell>
              <TableCell align='center'>Fulfillments</TableCell>
              <TableCell align='center'>Voucher Fulfillments</TableCell>
              {isActionsColumnVisible && <TableCell align='right'>Actions</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <ComponentTableRow
                key={item.id}
                campaignComponent={item}
                onItemClick={onRowClick}
                isActionsColumnVisible={isActionsColumnVisible}
              />
            ))}
          </TableBody>
        </Table>
        <Pagination {...paginationProps} />
      </>
    );
  };

  return (
    <LoadedContent<CampaignComponent>
      error={error}
      loading={loading}
      items={campaignComponents}
      renderData={renderData}
    />
  );
};
